import React from "react";
import {
  Card,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import ColoredLogo from "../misc/ColoredLogo";

const ExperienceCard = ({ logoSrc, company, subtitle, link, time, points }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        padding: 2,
        gap: 2,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          width: isMobile ? "100%" : "350px",
          display: "flex",
          justifyContent: "center",
          pr: isMobile ? "" : 4,
        }}
      >
        <ColoredLogo
          src={logoSrc}
          alt={`${company} logo`}
          color={theme.palette.mode === "dark" ? "#ddd" : "#333"}
          size={isMobile ? 200 : 300}
          sx={{ width: "100%", maxHeight: isMobile ? "48px" : "64px" }}
        />
      </Box>

      {/* Details */}
      <Box sx={{ flexGrow: 1, textAlign: isMobile ? "center" : "left" }}>
        <Typography variant="h6">{company}</Typography>
        <Typography variant="body2" color="textSecondary">
          {time}
        </Typography>

        {/* Experience Points */}
        <Box sx={{ mt: 3 }}>
          {points.map((point, index) => (
            <Typography key={index} variant="body2" sx={{ mb: 1 }}>
              • {point}
            </Typography>
          ))}
        </Box>

        <Button
          variant="contained"
          color="primary"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<LaunchIcon />}
          sx={{ mt: 2 }}
        >
          {subtitle}
        </Button>
      </Box>
    </Card>
  );
};

export default ExperienceCard;
